<template>
  <div class="agreement-builder">
    <draggable
      tag="ul"
      class="list-group"
      group="row"
      :list="rows"
      v-bind="dragOptions"
      handle=".handle"
    >
      <AgreementRow
        class="builder-list-group-item"
        v-for="(row, index) in rows"
        :key="row.id"
        :rowIndex="index"
        :columns="row.columns"
        :type="type"
        @removeRow="handleRemoveRow"
        @addRow="handleAddRow"
        @addElement="handleAddElement"
        @removeElement="handleRemoveElement"
        @contentChange="handleContentChange"
        @columnChange="handleColumnChange"
      />
    </draggable>
    <AddRow
      v-if="rows.length === 0"
      style="position: absolute; top: 30%; left: 50%; transform: translate(-50%, -50%);"
      @addRow="handleAddRow(1)"
    />
  </div>
</template>

<script>
  import { VueEditor } from 'vue2-editor';
  import Editor from './row/elements/editor/Editor';
  import AgreementRow from './row/Row';
  import AddRow from './row/AddRow';
  import draggable from 'vuedraggable';
  import generateId from './utils/generateId';

  export default {
    props: ['data', 'type'],
    data() {
      return {
        drag: false,
        rows: [],
      };
    },
    computed: {
      dragOptions() {
        return {
          animation: 500,
          group: 'row',
          disabled: false,
          ghostClass: 'ghost'
        };
      }
    },
    methods: {
      handleRemoveRow(rowIndex) {
        this.rows.splice(rowIndex, 1);
      },
      handleAddRow(rowIndex) {
        this.rows.splice(rowIndex, 0, {
          columns: [{
            id: generateId('column'),
            contents: [{
              id: generateId('element'),
              value: {
                'ops': [{ 'insert': ' \n' }]
              }
            }]
          }],
          id: generateId('row'),
        });
      },
      handleAddElement(rowIndex, columnIndex, contentIndex) {
        this.rows[rowIndex].columns[columnIndex].contents.splice(contentIndex, 0, {
          id: generateId('element'),
          value: {
            'ops': [{ 'insert': ' \n' }]
          },
        });
      },
      handleRemoveElement(rowIndex, columnIndex, contentIndex) {
        this.rows[rowIndex].columns[columnIndex].contents.splice(contentIndex, 1);
      },
      handleContentChange(value, rowIndex, columnIndex, contentIndex) {
        this.rows[rowIndex].columns[columnIndex].contents[contentIndex].value = value;
      },
      handleColumnChange(value, rowIndex) {
        if (value > this.rows[rowIndex].columns.length) {
          const addCount = value - this.rows[rowIndex].columns.length;
          for (let i = 0; i < addCount; i++) {
            this.rows[rowIndex].columns.push({
              id: generateId('column'),
              contents: []
            });
          }
        } else if (value < this.rows[rowIndex].columns.length) {
          const remove = this.rows[rowIndex].columns.length - value;
          for (let i = 0; i < remove; i++) {
            this.rows[rowIndex].columns.splice(-1, 1);
          }
        }
      },
    },
    mounted() {
      this.rows = this.data;
    },
    components: {
      VueEditor,
      Editor,
      AgreementRow,
      draggable,
      AddRow,
    },
  };
</script>

<style>
  .list-group {
    padding-left: 0;
  }
  .agreement-builder {
    position: relative;
  }
</style>
